// noinspection DuplicatedCode
import {cs}         from "../chain-services";
import {fragments}  from "../fragments";
import {keyed}      from "../keyed";
import {Static}     from "../static";
import {reconcile} from "../../utils/collections/reconcile";

import {createRerenderNode} from "./common/create-rerender-node";
import {createValueNode}    from "./common/create-value-node";
import {HookRerenderNode}   from "./common/hook-rerender-node";
import {RenderValueNode}    from "./common/render-value-node";


/**
 * Each render in list would provide a value to the end result
 * Next in node render must always be called+rendered (once), even if it is shifted (vertically or horizontally)
 */

// IndependentList({
//     list: [].map((i) => ({
//         key: i,
//         render: (next) => next(123),
//     })),
//     next,
// })
export const IndependentList = ({list, next: rootNext}) => cs(
    ["control", ({}, next) => Static({
        getInitValue: () => {
            let nodes = [];

            const rootRenderNode = createRerenderNode();

            return ({
                rootRenderNode,

                markAllForRerender: () => {
                    for (const node of nodes) {
                        node.markForRerender();
                    }
                    rootRenderNode.markForRerender();
                },

                getNode: (i) => nodes[i],

                getValueList: () => {
                    return nodes.map((n) => n.getValue());
                },

                rootRender: {
                    isActive: () => !rootRenderNode.isRenderScheduled(),
                    render: rootRenderNode.scheduleRender,
                },

                getNodes: () => nodes,
                setNodes: (nodes1) => nodes = nodes1,
            });
        },
        next,
    })],
    ({control}, next) => {
        control.setNodes(
            reconcileNodes(control.getNodes(), list)
        );
        control.markAllForRerender();
        return next();
    },
    ({control}) => fragments(
        list.map(({render, key}, i) => cs(
            keyed(key),
            ["node", (_, next) => next(control.getNode(i))],
            ({node}, next) => HookRerenderNode({
                node,
                next,
            }),
            ({node}) => render(
                (value) => RenderValueNode({
                    value,
                    setValueGetter: node.setValueGetter,
                    renderNext: control.rootRender,
                }),
            ),
        )),

        cs(
            ({}, next) => HookRerenderNode({
                node: control.rootRenderNode,
                next,
            }),
            ({}, next) => {
                // console.log(control.getNodes())
                if (control.getNodes().some((n) => n.isRenderScheduled())) {
                    // This could be due to React's async rendering where sibling nodes are not rendered by chronological order
                    // If this happens, add IgnoreUpdate node so that the root render is forced to run after all shadow nodes rendered
                    throw "[INDEPENDENT LIST] rootRender is called before all shadow nodes render";
                }
                return next();
            },
            ({}) => rootNext(
                control.getValueList()
            ),
        ),
    ),
);


// IndependentList1({
//     list: [].map((i) => (next) => next(123)),
//     next,
// })

export const IndependentList1 = ({list, next: rootNext}) => IndependentList({
    list: list.map((render, i) => ({key: i, render})),
    next: rootNext,
});

const reconcileNodes = (nodes, newList) => {
    const {updates} = reconcile(nodes, newList, (n1, n2) => n1.key === n2.key);

    return updates.map(({newObj, oldObj, oldIndex}) => (
        oldIndex != null ? (
            oldObj
        ) : {
            key: newObj.key,
            ...createValueNode(),
            ...createRerenderNode(),
            scheduleRender: null,
            setRerenderer: null,
        }
    ));
};

